// extracted by mini-css-extract-plugin
export default {"root":"StartStopDelayInput_root__cWSHc"};